module.exports = __webpack_public_path__ + "static/media/play-circle.5a7ddd36.svg";